import { createSlice } from "@reduxjs/toolkit";
import { deleteUnit, getUnitById, getUnitList, updateUnit } from "./ThunkActions";
import { iUnitState, REDUCER_NAME } from "./Types";

const initialState: iUnitState = {
  isLoading: false,
  unit: null,
  errorMessage: null,
  unitList: [],
};

export const unitsSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetUnitState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getUnitById.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = null;
    })
    .addCase(getUnitById.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload?.data?.data) {
        state.unit = action.payload.data.data;
      }
    })
    .addCase(getUnitById.rejected, (state, action) => {
      state.isLoading = false;
      // @ts-expect-error
      state.errorMessage = action.payload?.message || "Failed to fetch unit data";
    })
      .addCase(getUnitList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnitList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.unitList = payload.data;
          state.isLoading = false;
        }
      })
      .addCase(getUnitList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch unit data";
        state.isLoading = false;
      })
      .addCase(updateUnit.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(updateUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data?.data) {
          const updatedUnit = action.payload.data.data;
          state.unitList = state.unitList.map(unit => 
            unit.id === updatedUnit.id ? updatedUnit : unit
          );
        }
      })
      .addCase(updateUnit.rejected, (state, action) => {
        state.isLoading = false;
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to update unit";
      })
      .addCase(deleteUnit.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        state.isLoading = false;
        const unitId = action.meta.arg.unitId;
        state.unitList = state.unitList.filter(unit => unit.id !== unitId);
      })
      .addCase(deleteUnit.rejected, (state, action) => {
        state.isLoading = false;
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to delete unit";
      });
  },
});

export const { resetUnitState } = unitsSlice.actions;
export default unitsSlice.reducer;